import { useState, useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { useTranslation } from "react-i18next";
// Redux
import { useDispatch } from "react-redux";
import { validateClinician, successfulToken, failedToken } from "../redux/clinicianDucks";
// Constants
import { pathHomePage } from "./constants";

const VerifyToken = () => {
  const [redirectToHome, setRedirectToHome] = useState(false);
  const { clinicianToken } = useParams();
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  const validateClinicianToken = async () => {
    if (clinicianToken) {
      try {
        const clinicianData = jwt_decode(clinicianToken);
        if (clinicianData.data.CLINICIAN_ID) {
          if (!clinicianData.data.hasOwnProperty("AISN_GROUP")) {
            const user = clinicianData.data.CLINICIAN_USER || "";
            const password = clinicianData.data.PASSWORD || "";
            dispatch(validateClinician({ user, password, errorMessage: t("login_incorrectDataMessage"), isPasswordEncrypted: true }));
          } else {
            clinicianData.data.token = clinicianToken;
            const data = clinicianData.data;
            dispatch(successfulToken({ data }));
          }
        } else {
          dispatch(failedToken());
          setRedirectToHome(true);
        }
      } catch (error) {
        console.log("invalid jwt: ", error);
        dispatch(failedToken());
        setRedirectToHome(true);
      }
    } else {
      dispatch(failedToken());
      setRedirectToHome(true);
    }
  };

  useEffect(() => {
    validateClinicianToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (redirectToHome) {
    return <Redirect to={pathHomePage} />;
  }
};

export default VerifyToken;
